import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "@/shared/i18n/en";

/** English first; add a language by registering another resource bundle here. */
void i18n.use(initReactI18next).init({
  lng: "en",
  fallbackLng: "en",
  resources: { en: { translation: en } },
  interpolation: { escapeValue: false }, // React already escapes; nothing here is ever injected as HTML
  returnNull: false,
});

export { i18n };
